export default "__VITE_ASSET__B8lfCQW1__"